<template>
  <span v-if="hasContent" class="d-inline-block">
    <template v-if="prefix">{{ prefix }}</template>
    <template v-if="content">{{ content }}</template>
    <template v-if="suffix">{{ suffix }}</template>
  </span>
</template>

<script>
import constants from '@/constants';

export default {
  name: 'LocaleText',

  props: {
    text: {
      type: [String, Object],
      default: null,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
  },

  computed: {
    lang() {
      return this.$i18n.locale();
    },

    content() {
      if (typeof this.text === 'string') {
        return this.text;
      }

      if (this.text == null || typeof this.text !== 'object') {
        return null;
      }

      return (
        this.text[this.lang] ||
        this.text[constants.locale.default] ||
        this.text[constants.locale.fallback] ||
        Object.values(this.text)[0]
      );
    },

    hasContent() {
      return !!(this.content || this.prefix || this.suffix);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/LocaleText.vue